import { useEffect, useState } from 'react';
import { healthService, type HealthStatus } from '../lib/services/health';

export interface UseHealthCheckOptions {
  checkInterval?: number; // milliseconds
  enablePeriodicChecks?: boolean;
}

export function useHealthCheck(options: UseHealthCheckOptions = {}) {
  const {
    checkInterval = 30000, // 30 seconds default
    enablePeriodicChecks = false, // Default to one-time check only
  } = options;

  const [healthStatus, setHealthStatus] = useState<HealthStatus>(healthService.getStatus());

  useEffect(() => {
    // Subscribe to health status changes
    const unsubscribe = healthService.subscribe(setHealthStatus);

    // Start periodic checks if enabled
    if (enablePeriodicChecks) {
      healthService.startPeriodicChecks(checkInterval);
    } else {
      // Just do an initial check
      healthService.checkHealth();
    }

    // Cleanup
    return () => {
      unsubscribe();
      // Only stop periodic checks if we started them
      if (enablePeriodicChecks) {
        healthService.stopPeriodicChecks();
      }
    };
  }, [checkInterval, enablePeriodicChecks]);

  return healthStatus;
}
